
import Vue from 'vue';
import { mapState } from 'vuex';

import i18n from '@/i18n';
import { ListStatus } from '@/store/types';
import SelectInput from '@/components/controls/select-input.vue';

export default Vue.extend({
  name: 'RegionSelectionControl',
  inheritAttrs: false,
  inject: ['$validator'],
  components: {
    SelectInput,
  },
  props: {
    name: {
      type: String,
      default: 'region',
    },
    label: {
      type: String,
      default: i18n.t('Region'),
    },
    value: {
      type: Number,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['regions', 'regionsStatus']),
    areRegionsLoaded() {
      return this.regionsStatus === ListStatus.Loaded;
    },
    stringifiedValue() {
      return this.value ? String(this.value) : '';
    },
  },
});
